import { NgModule } from "@angular/core";

import { StrapiRichTextComponent } from "./strapi-rich-text/strapi-rich-text.component";
import { StrapiQuoteComponent } from "./strapi-quote/strapi-quote.component";
import { StrapiMediaComponent } from "./strapi-media/strapi-media.component";
import { BlockResolverComponent } from "./block-resolver/block-resolver.component";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { SharedModule } from "../shared/shared.module";

@NgModule({
  declarations: [
    StrapiRichTextComponent,
    StrapiQuoteComponent,
    StrapiMediaComponent,
    BlockResolverComponent,
  ],
  imports: [CommonModule, RouterModule, SharedModule],
  exports: [
    StrapiRichTextComponent,
    StrapiQuoteComponent,
    StrapiMediaComponent,
    BlockResolverComponent,
  ],
  entryComponents: [
    StrapiMediaComponent,
    StrapiQuoteComponent,
    StrapiRichTextComponent,
  ],
})
export class StrapiModule {}
